// extracted by mini-css-extract-plugin
export default {"generalAccess":"SharePrivacy_generalAccess__RqO7L","sectionLabel":"SharePrivacy_sectionLabel__B46oe"};